import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/OutgoingPayments';

const OutgoingPayments = () => ((orgContainer(InnerComponent)));

export default OutgoingPayments;
